var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.7125 0.5H22.2875C8.6375 0.5 0.5 8.6375 0.5 22.2875V53.675C0.5 67.3625 8.6375 75.5 22.2875 75.5H53.675C67.325 75.5 75.4625 67.3625 75.4625 53.7125V22.2875C75.5 8.6375 67.3625 0.5 53.7125 0.5ZM55.925 29.375L34.6625 50.6375C34.1375 51.1625 33.425 51.4625 32.675 51.4625C31.925 51.4625 31.2125 51.1625 30.6875 50.6375L20.075 40.025C18.9875 38.9375 18.9875 37.1375 20.075 36.05C21.1625 34.9625 22.9625 34.9625 24.05 36.05L32.675 44.675L51.95 25.4C53.0375 24.3125 54.8375 24.3125 55.925 25.4C57.0125 26.4875 57.0125 28.25 55.925 29.375Z",
    fill: "#00C897"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/Vector1.1bc4fd963d978c1f3a7bd53eea3500a0.svg";
export { ForwardRef as ReactComponent };